import { AbstractMesh, SceneLoader, TransformNode, AnimationGroup } from '@babylonjs/core';
import { GLTFFileLoader } from '@babylonjs/loaders';
import { Tool } from './../utils/tools';

export class ModelLoader {
  private characterMap: Map<string, any> = new Map();
  private modelMap: Map<string, AbstractMesh> = new Map();
  private static _instance: ModelLoader;

  private constructor() {
    SceneLoader.RegisterPlugin(new GLTFFileLoader());
    GLTFFileLoader.IncrementalLoading = false;
  }

  static get instance() {
    if (!this._instance) this._instance = new ModelLoader();
    return this._instance;
  }
  async getModel(url: string, visibility: number = 1, canDispose: number = 0) {
    return new Promise<any>(async (resolve: any, reject: any) => {
      if (this.modelMap.has(url) && canDispose == 0) {
        resolve(this.modelMap.get(url) as AbstractMesh);
      } else {
        SceneLoader.ImportMesh('', '', url, undefined, (meshes, particleSystems: any[], skeletons: any[], animationGroups: any[]) => {
          let mesh = meshes[0] as AbstractMesh;
          console.log(url);
          if (animationGroups && animationGroups.length > 0) {
            mesh.animations = animationGroups;
          }
          this.modelMap.set(url, mesh);
          if (visibility == 0 && (mesh as TransformNode).getChildMeshes) {
            (mesh as TransformNode).getChildMeshes().forEach((c) => {
              c.visibility = 0;
            })
          }
          resolve(mesh);
        }, null, (err) => {
          reject(err);
        });
      }
    })
  }
  private cloneAnimations(groups: AnimationGroup[]) {
    let temp = [];
    for (let i = 0; i < groups.length; i++) {
      const a = groups[i] as AnimationGroup;
      const b = a.clone(a.name + "_" + Tool.randomStr(6));
      temp.push(b)
    }
    return temp;
  }

  hasModel(url: string) {
    return this.modelMap.has(url);
  }
}
